module.exports = __webpack_public_path__ + "img/problem_title_bac.924cf461.png";